// @flow

import type { FavoriteContact } from '@gandi/redux-resource-contactbook';
import type { FetchResponse } from '@gandi/resource/redux';

import { POST } from 'gandi.redux-fetcher';

import type { Dispatch } from '../../../../types';
import type { EditableRole } from '../../types';

export type ContactValidationProps = {
  contact: FavoriteContact,
  role: EditableRole,
};

export const contactValidation =
  (props: ContactValidationProps): (Dispatch => any) =>
  dispatch => {
    // we use .com as lightest/standard validator
    // more explanation: https://gitlab.corp.gandi.net/admin-v5/admin/merge_requests/3590#note_402709
    const fqdn = 'contactbook.com';
    const url = `/contactvalidation/validfor/${fqdn}`;

    const body = {
      ...props.contact,
      roles: [props.role],
    };

    return dispatch(
      POST(url, body, {
        on400: (response: FetchResponse<>) => Promise.reject(response),
        // $FlowFixMe[incompatible-call]
        not2XX: (response: FetchResponse<>) => Promise.reject(response),
      }),
    );
  };
